import { onlyAllowNumbers } from './_utilities';

// Module startup
const init = () => {
    // Get the zip input fields and convert to array
    const zipInputArray = Array.prototype.slice.call(
        document.querySelectorAll('.field-zip')
    );

    // Disallow characters entered into zip input
    if (zipInputArray !== null && zipInputArray.length > 0) {
        Array.prototype.map.call(zipInputArray, (el) => {
            onlyAllowNumbers(el);
        });
    }
};

export { init };
